declare var require: any


var React = require('react');
var ReactDOM = require('react-dom');


import { HashRouter as Router, Switch, Route } from 'react-router-dom';

import { Helmet } from "react-helmet";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import withAuth from './withAuth.jsx';
import Navbar from './components/Navbar';
import Login from './components/Login';
// import CreateProfile from './components/CreateProfile';
import Profile from './components/Profile';
import Calendar from './components/Calendar';
import Home from './components/Home';
import Summary from './components/AdminItems/Summary';
import UserTabs from './components/AdminItems/Users'
import TaskTabs from './components/AdminItems/Tasks'
import BillingTabs from './components/AdminItems/Site'
import AdminPanel from './components/AdminControlPanel';
import Timesheet from './components/Timesheet';
import ReportTabs from './components/AdminItems/Reports';
import ImportTabs from './components/AdminItems/Import';
import EventTabs from './components/AdminItems/Events';



export class App extends React.Component {
    render() {
        return (
            <div>
                <Helmet>
                    <meta name="viewport" content="initial-scale=1, width=device-width" />
                </Helmet>
                <Router>
                    <Navbar/>
                    <Switch>
                        <Route path='/Calendar' component={withAuth(Calendar)} />
                        <Route path='/Home' component={withAuth(Home)} />
                        <Route path='/Admin' component={withAuth(AdminPanel)} />
                        <Route path='/Summary' component={withAuth(Summary)} />
                        <Route path='/Users' component={withAuth(UserTabs)} />
                        <Route path='/Tasks' component={withAuth(TaskTabs)} />
                        <Route path='/Site' component={withAuth(BillingTabs)} />
                        <Route path='/Reports' component={withAuth(ReportTabs)} />
                        <Route path='/Profile' component={withAuth(Profile)} />
                        <Route path='/Import' component={withAuth(ImportTabs)} />
                        <Route path='/Events' component={withAuth(EventTabs)} />
                        <Route path='/' component={Login} />
                    </Switch>
                </Router>
            </div>
        );
    }
}

ReactDOM.render(<App/>, document.getElementById('root'));